import api from '@/api'
import { formatRatio } from '@/utils'

let timer = null
const account = {
  state: {
    user: null,
    countdown: 0,
    stats: {
      totalKeywordsCount: 0, // 配置关键词个数
      fifthPageKeywordsCount: 0, // 前5页排名关键词个数
      firstPageKeywordsCount: 0, // 第一页排名关键词个数
      targetKeywordsCount: 0, // 目标排名关键词个数
      targetCompleteRatio: 0 // 目标达成率
    },
    combo: { // 套餐信息
      name: '',
      productType: 0, // 0: 空, 1: 标准套餐, 2: 官方套餐,
      isRecommended: false,
      effectiveTime: 0,
      remainTime: 0,
      costTime: 0
    }
  },

  mutations: {
    LOGIN (state, { user }) {
      state.user = user
    },

    LOGOUT (state) {
      state.user = null
    },

    SET_COUNTDOWN (state) {
      state.countdown = 59
      clearInterval(timer)
      timer = setInterval(() => {
        if (state.countdown-- <= 0) {
          clearInterval(timer)
          state.countdown = 0
        }
      }, 1000)
    },

    REMOVE_COUNTDOWN (state) {
      clearInterval(timer)
      state.countdown = 0
    },

    setAccountStats (state, stats) {
      state.stats = { ...state.stats, ...stats }
    },

    setAccountCombo (state, combo) {
      state.combo = { ...state.combo, ...combo }
    }
  },

  actions: {
    login ({ commit }, data) {
      return api.account.login({
        username: data.username,
        password: data.password,
        rememberMe: data.rememberMe
      }).then(response => {
        return response
      })
    },

    logout ({ commit }) {
      return api.account.logout()
    },

    changePassword ({ commit }, data) {
      return api.account.changePassword(data)
    },

    getUserInfo ({ commit }) {
      return api.account.getUserInfo().then(response => {
        const { account, ability, name, stage, productType } = response.data.customer
        const user = {
          id: account.userId,
          email: account.email,
          username: account.username,
          telephone: '',
          avatar: 1806264099572807,
          cellphone: account.mobileNumber,
          companyName: name,
          configStatus: stage || 0,
          package: {
            name: productType || '标准套餐',
            startTime: ability.termStart,
            endTime: ability.termEnd,
            keywords: ability.keywords,
            firstPagesTargetKeywords: ability.firstPagesKeywords
          }
        }

        commit('LOGIN', { user })
        return response
      }).catch(error => {
        console.log('get user info error', error)
      })
    },

    /**
     * 查询用户，从检索系统
     */
    queryUser ({ commit }, data) {
      return api.search.queryCustomers(data).then(response => {
        const { total, results } = response.data
        const item = results[0]

        if (total === 1) {
          commit('setAccountStats', {
            totalKeywordsCount: item.ability_keywords,
            fifthPageKeywordsCount: item.rank_count,
            firstPageKeywordsCount: item.first_page_count,
            targetKeywordsCount: item.ability_firstpages_keywords,
            targetCompleteRatio: formatRatio(item.goal_completion_rate)
          })
          commit('setAccountCombo', {
            isRecommended: item.ability_term_end > 0,
            remainTime: item.remains,
            costTime: item.used
          })
        }
      })
    },

    // 获取用户套餐信息
    getComboInfo ({ commit }, data) {
      return api.account.getComboInfo(data).then(response => {
        const { product } = response.data

        if (product) {
          commit('setAccountCombo', {
            name: product.name,
            productType: product.productType,
            effectiveTime: product.effectiveTime
          })
        }
      })
    },

    getImageCaptcha ({ commit }, data) {
      return api.account.getImageCaptcha()
    },

    verifyAccount ({ commit }, data) {
      return api.account.verifyAccount(data)
    },

    verifyMessage ({ commit }, data) {
      return api.account.verifyMessage(data)
    },

    resetPassword ({ commit }, data) {
      return api.account.resetPassword(data)
    },

    getPhoneCaptcha ({ commit }, data) {
      return api.account.sendMessage(data).then(response => {
        commit('SET_COUNTDOWN')
        return response
      })
    }
  }
}

export default account
